import React from 'react';

import { ListImage, Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { JobDetailsContainerStyled } from './style';

type TechnicalSpecificationDataType = {
  specification: string;
  experience: string;
  cost: string;
  qualifications: string;
  pastReferences?: string[];
};
const TechnicalSpecification = ({
  specification,
  experience,
  cost,
  qualifications,
  pastReferences = [],
}: TechnicalSpecificationDataType) => {
  return (
    <JobDetailsContainerStyled>
      <Typography
        variant="normal"
        className="title"
        fontColor="secondary"
        strong
      >
        TECHNICIAN SPECIFICATION
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <div style={{ display: 'block' }}>
            <Typography className="title">Specification :</Typography>
            <Typography className="value">{specification}</Typography>
          </div>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Experience :</Typography>
          <Typography className="value">{experience}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Cost Estimation :</Typography>
          <Typography className="value">{cost}</Typography>
        </InfoRowStyled>
        {pastReferences?.length > 0 && (
          <InfoRowStyled>
            <div style={{ display: 'block' }}>
              <Typography className="title">
                Reference of Past Project :
              </Typography>
              <ListImage
                imageWidth="100px"
                imagesURL={pastReferences.map((referenceUrl, index) => ({
                  id: `${index}`,
                  URL: referenceUrl,
                }))}
              />
            </div>
          </InfoRowStyled>
        )}
        <InfoRowStyled>
          <Typography className="title">
            Qualifications or Certifications :
          </Typography>
          <Typography className="value">{qualifications}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </JobDetailsContainerStyled>
  );
};

export default TechnicalSpecification;
